export default __webpack_public_path__ + "images/55_1_image.jpg";